import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import { TextValidator } from 'react-material-ui-form-validator';
import { withStyles } from '@material-ui/core/styles';

import CardForm from '../../components/CardForm';
import * as api from '../../services/api/auth';

class ForgotPassword extends Component {
  state = {
    email: '',
    setStorageValue: null,
    setStorageSpeciality: null,
    buttonDisable: false,
  };

  componentDidMount() {
    const getUrl = sessionStorage.getItem('redirect1');
    const getUrl2 = sessionStorage.getItem('redirect2');
    if (getUrl) {
      this.setState({
        setStorageValue: getUrl,
        setStorageSpeciality: null,
      });
      sessionStorage.removeItem('redirect2');
    }
    if (getUrl2) {
      this.setState({
        setStorageSpeciality: getUrl2,
        setStorageValue: null,
      });
      sessionStorage.removeItem('redirect1');
    }
  }

  // componentDidMount() {
  //   const parsed = queryString.parse(this.props.location.search);
  //   if (parsed && parsed.redirect1) {
  //     sessionStorage.setItem('redirect1', parsed && parsed.redirect1);
  //     this.setState({
  //       setStorageValue: parsed.redirect1,
  //       setStorageSpeciality: null
  //     })
  //   } if (parsed && parsed.redirect2) {
  //     sessionStorage.setItem('redirect2', parsed && parsed.redirect2);
  //     this.setState({
  //       setStorageSpeciality: parsed.redirect2,
  //       setStorageValue: null
  //     })
  //   }
  // }

  handleEmailChange = event => {
    this.setState({ email: event.target.value });
  };

  handleSubmit = async () => {
    const { history } = this.props;
    const { email, setStorageValue, setStorageSpeciality } = this.state;
    this.setState({
      buttonDisable: true,
    });
    await api.resetPassword({ email });
    // if (setStorageSpeciality !== null) {
    //   sessionStorage.removeItem('redirect1');
    //   if (process.env.CLIENT_URL == 'undefined' || process.env.CLIENT_URL == undefined) {
    //     // window.location.assign(process.env.CLIENT_URL + '/specialties/search');
    //     sessionStorage.removeItem('redirect2');
    //    this.setState({
    //     setStorageSpeciality : null
    //    })
    //     window.location.assign('https://qwell.com/specialties/search');
    //   } else {
    //     sessionStorage.removeItem('redirect2');
    //     // window.location.assign('https://qwell.com/specialties/search');
    //     window.location.assign(process.env.REACT_APP_CLIENT_URL + '/specialties/search');
    //   }
    // }  else if (sessionStorageValue !== null) {
    //   this.setState({
    //     sessionStorageValue: null
    //   });
    //   sessionStorage.removeItem('redirect1');
    //   sessionStorage.removeItem('redirect2');
    //   // window.location.assign(process.env.REACT_APP_CLIENT_URL + '/concierge-pricing');
    //   window.location.assign('https://qwell.com/concierge-pricing');
    // } else {
    //   history.push('/password-reset/confirmation');
    //   window.location.href = process.env.REACT_APP_HOMEPAGE_URL;
    // }
    if (setStorageValue !== null) {
      history.push('/password-reset/confirmation');
      sessionStorage.removeItem('redirect1');
      this.setState({
        setStorageValue: null,
        setStorageSpeciality: null,
      });
      // window.location.assign(
      //   process.env.REACT_APP_HOMEPAGE_URL + '?redirect1=/concierge-pricing'
      // );
    } else if (setStorageSpeciality !== null) {
      sessionStorage.removeItem('redirect2');
      this.setState({
        setStorageSpeciality: null,
        setStorageValue: null,
      });
      history.push('/password-reset/confirmation');
      // window.location.assign(
      //   process.env.REACT_APP_HOMEPAGE_URL + '?redirect2=/specialties/search'
      // );
    } else {
      history.push('/password-reset/confirmation');
      // window.location.href = process.env.REACT_APP_HOMEPAGE_URL;
    }
    // if (sessionStorageValue !== '') {
    //   history.push('/password-reset/confirmation');
    //   window.location.href = `${process.env.REACT_APP_HOMEPAGE_URL + "?redirect1=/concierge-pricing"}`;
    // } else {
    //   history.push('/password-reset/confirmation');
    //   window.location.href = process.env.REACT_APP_HOMEPAGE_URL;
    // }
    // history.push('/password-reset/confirmation');
    // window.location.href = process.env.REACT_APP_HOMEPAGE_URL;
    this.setState({
      setStorageValue: null,
      setStorageSpeciality: null,
      buttonDisable: false,
    });
  };

  render() {
    const {
      email,
      setStorageValue,
      setStorageSpeciality,
      buttonDisable,
    } = this.state;
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <CardForm
          headerText="Set your new password"
          headerSubText="Once you fill out the from below we'll send you an email with instructions on how to get a new password."
          errorText="No user found with this email address."
          submitText="Send Email"
          onSubmit={this.handleSubmit}
          buttonDisable={buttonDisable}
        >
          <Grid item xs={12} className={classes.formControl}>
            <TextValidator
              fullWidth
              label="Email"
              value={email}
              variant="outlined"
              onChange={this.handleEmailChange}
              validators={['required']}
              errorMessages={['Required']}
            />
          </Grid>
        </CardForm>
      </div>
    );
  }
}

const styles = () => ({
  root: {},
  formControl: {
    marginBottom: '24px',
  },
});

export default withStyles(styles)(ForgotPassword);
